import env from "../env"
import {getModels} from "../api/api"
export default {
    // 判断图片路径
    isImgUrl(url) {
        let reg = /^http/;
        if (reg.test(url)) {
            return url
        } else {
            return ""
        }
    },
    // 图片列表
    isImgList(url) {
        let reg = /^http/;
        let arr = [];
        if (reg.test(url)) {
            arr.push(url);
        } else {
            return arr
        }
        return arr
    },
    // 格式化时间
    isDate(date) {
        if (date == null) {
            return ""
        } else {
            return date.split(" ")[0]
        }
    },
    // 格式化排放
    isGeshi(str) {
        if(!str)return ''
        return JSON.parse(str).join(",")
    },
    // 判断权限
    checkPer(uri) {
        var allPer = [];
        let strong = window.localStorage;
        let obj = JSON.parse(strong.getItem("auth_permissions"));
        if (obj) {
            obj.forEach((item) => {
                allPer.push(item.path)
            })
        }
        return allPer.indexOf(uri) >= 0;
    },
    // 替换base64格式，转变为在线连接
    baseUrl(form) {
        // activities_con
        let str = form.activities_con;
        // console.log("str",str);
        // 解析P标签
        var p = /<p[^>]*>(?:(?!<\/p>)[\s\S])*<\/p>/gi;
        var pl = str.match(p); // 拿到所有的P标签
        if (pl == null) {
            return;
        }
        // console.log("原来的", pl)
        pl.forEach((item, index) => {
            var img = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;
            var base = item.match(img);
            if (base != null) {
                var src = /src=['"]([^'"]+)/g;
                let reg = /^http/;
                var baseSrc = base[0].match(src);
                let base64 = baseSrc[0].slice(5);
                if (!reg.test(base64)) {
                    let arr = base64.split(","); // "data:image/png;base64", "base64"
                    let mime = arr[0].match(/:(.*?);/)[1]; // 得到 image/png
                    let suffix = mime.split("/")[1]; // png
                    // 解码使用base64
                    let bstr = atob(arr[1]); // atob(转换base64)
                    let n = bstr.length; // 获取base长度
                    let u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    let file = new File([u8arr], `01.${suffix}`, {
                        type: mime,
                    });
                    var xhr, formData;
                    xhr = new XMLHttpRequest();
                    xhr.withCredentials = false;
                    xhr.open("POST", env.basUrl + "api/obs-upload-set");
                    xhr.onload = function () {
                        var json;
                        json = JSON.parse(xhr.responseText);
                        let p = `<p><img src="${json.file_path}"/></p>`
                        pl[index] = p;
                        let bule = pl.every(list => {
                            return list.indexOf("base64") == -1
                        })
                        if (bule) {
                            let conteant = pl.join("");
                            form.activities_con = conteant;
                            console.log(form);
                            // return form;
                        }
                    };
                    formData = new FormData();
                    formData.append("file", file);
                    xhr.setRequestHeader(
                        "Authorization",
                        `Bearer ${window.localStorage.getItem("token")}`
                    );
                    xhr.send(formData);
                }
            }
        });
    },
}